export const eventType = {
  event_sale: 'event_sale',
  clearance_sale: 'clearance_sale',
  flash_sale: 'flash_sale',
  pre_sale: 'pre_sale'
}

export const eventSaleTypes = {
  eventSale: 'event_sale',
  flashSale: 'flash_sale',
  clearanceSale: 'clearance_sale',
  preSale: 'pre_sale'
}

export const eventSalePaths = {
  eventSale: 'sale',
  flashSale: 'flashsale',
  clearanceSale: 'clearance-sale'
}

export const eventSaleLabels = {
  eventSale: 'Event Sale',
  flashSale: 'Flash Sale',
  clearanceSale: 'Clearance Sale',
  preSale: 'Pre Sale'
}

export const eventSaleFileNames = {
  bannerMobile: 'banner_mobile',
  banner: 'banner'
}

export const eventSaleProductPeriods = {
  ongoing: 'ongoing'
}

export const getEventSalePathFromType = (type) => {
  switch (type) {
    case eventSaleTypes.eventSale:
      return eventSalePaths.eventSale
    case eventSaleTypes.flashSale:
      return eventSalePaths.flashSale
    case eventSaleTypes.clearanceSale:
      return eventSalePaths.clearanceSale
    default:
      return ''
  }
}

export const getEventSaleLabelFromType = (type) => {
  switch (type) {
    case eventSaleTypes.eventSale:
      return eventSaleLabels.eventSale
    case eventSaleTypes.flashSale:
      return eventSaleLabels.flashSale
    case eventSaleTypes.clearanceSale:
      return eventSaleLabels.clearanceSale
    case eventSaleTypes.preSale:
      return eventSaleLabels.preSale
    default:
      return ''
  }
}
